import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes} from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import NavBar from './NavBar';
import './TermsOfService.css';
import abt_first from './assets/images/Privacy-TOS-banner-2.jpg';
import abt_first1 from './assets/images/Sector-Page-Top-banner-2.jpg';
import logo from './assets/images/favicon1.webp';
import logo1 from './assets/images/0040C0.png';

const TermsOfService = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    document.title = "Terms Of Service – Bay Capital Advisors";
    
    // Find and update the favicon
    let favicon = document.querySelector("link[rel~='icon']");
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    favicon.href = logo; // Use your logo as favicon
    
    return () => {
      // Reset title when component unmounts if needed
      document.title = "Bay Capital Advisors";
    };
  }, []);
                    
                      const toggleMobileMenu = () => {
                        setIsMobileMenuOpen(!isMobileMenuOpen);
                      };
                    
                      const closeMobileMenu = () => {
                        setIsMobileMenuOpen(false);
                      };
  return (
    <div className="terms-of-service-page">
      <div className="mobile-menu-button" onClick={toggleMobileMenu}>
        {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
      </div>
      
      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="mobile-dropdown-overlay" onClick={closeMobileMenu}>
          <div className="mobile-dropdown" onClick={(e) => e.stopPropagation()}>
            <NavBar isMobile={true} closeMenu={closeMobileMenu} />
          </div>
        </div>
      )}
      <section class="hero10">
    
    
    <div class="blue-overlay"></div>
    
   
    <header class="header10">
    <NavBar />
    </header>

   
    <header className="terms-of-service-header">
      <h1>TERMS OF SERVICE</h1>
    </header>

  </section>
      <div className="terms-of-service-content">
        
          <p>1. The terms and conditions set out below apply to your use of Bay Capital Advisors’ website. Please read them. Specific terms apply to any use you make of the ‘Resources’ section at <a href="" style={{ color: 'inherit', textDecoration: 'inherit', fontSize:'1rem', fontfamily: "Raleway" }} >  www.baycapadvisors.com </a> and these are set out in paragraphs 16-22 below.</p>
          <p>
          2. “BCA” means Bay Capital Advisors, Inc. and any of its subsidiaries, affiliates, and related companies and references to the “Bay Capital Advisors Website” are to any of BCA’s websites including <a href="http://www.baycapadvisors.com/" style={{ color: 'inherit', textDecoration: 'inherit', fontSize:'1rem', fontfamily: "Raleway" }} > www.baycapadvisors.com </a>,<a href="http://www.baycapadvisors.net/" style={{ color: 'inherit', textDecoration: 'inherit', fontSize:'1rem', fontfamily: "Raleway" }} > www.baycapadvisors.net </a>,<a href="http://www.baycapitalpartners.com/" style={{ color: 'inherit', textDecoration: 'inherit', fontSize:'1rem', fontfamily: "Raleway" }} > www.baycapitalpartners.com </a>,<a href="http://www.baycorporate.com/" style={{ color: 'inherit', textDecoration: 'inherit', fontSize:'1rem', fontfamily: "Raleway" }} > www.baycorporate.com </a>,<a href="http://www.baycapitalpartners.net/" style={{ color: 'inherit', textDecoration: 'inherit', fontSize:'1rem', fontfamily: "Raleway" }} > www.baycapitalpartners.net </a>   (and any replacement URL of any such website) and also include, but are not limited to, the text, images, links, sounds, graphics and video sequences displayed in such websites (the “Materials”).
          </p>
          <p>
          3. By accessing any of the BCA Websites and any pages on the website you agree that you have read and accept these terms and conditions. If you do not agree, do not use the BCA Websites. The pages on the BCA Websites have been issued and approved by BCA, LLC, which is regulated under the laws of the United States and European Union. BCA is not a registered broker/dealer with any legal entity. It is your responsibility to be aware of and to observe all applicable laws and regulations for your country of residence.          
          </p>

          <p style={{ fontWeight: 'bold' }}>
          Bay Capital Advisors, Inc.
          </p>

          <p>
          4. Bay Capital Advisors, Inc. is a private company incorporated to conduct business in the United States, Canada, certain Asian countries, the UK, and the European Union. From time to time BCA may seek to do business in other countries and regions of the world. At such time BCA management will seek appropriate regulatory approval from local government agencies if such approvals are required by regulatory bodies within those countries. No information contained in these pages should be taken as a recommendation to buy, sell or hold the shares or other investments of any public or private company presented or discussed on the BCA Websites. Nothing on the BCA Websites or in the Materials constitutes or is intended to constitute financial or other advice and you should not act upon any information contained on the BCA Websites or in the Materials without first consulting a financial, legal or other professional adviser.         
           </p>
          

          <p style={{ fontWeight: 'bold' }}>
          US Residents
          </p>
          <p>
          5. Special rules are applicable when US Residents and other US persons access the BCA Websites. For US regulatory reasons, US residents are not permitted to access certain of the BCA Websites. BCA is not offering any securities or broker/dealer services in the United States or to US residents through any BCA website.
          </p>
          <p>
          6. A “US resident” includes any US person, as well as (i) any natural person who is only temporarily residing outside the United States, (ii) any account of a US person over which a non-US fiduciary has investment discretion or any entity, which, in either case, is being used to circumvent the registration requirements of the US Investment Company Act of 1940, and (iii) any employee benefit or pension plan that does not have as its participants or beneficiaries persons substantially all of whom are not US persons. In addition, for these purposes, if an entity either has been formed or is operated for the purpose of investing in a particular security or obtaining a particular service, or facilitates individual investment decisions, none of the beneficiaries or other interest holders of such entity may be US Residents. Terms used in this paragraph (including the term “US person”) have the meanings given to them in Regulation S under the US Securities Act of 1933.          
          </p>
          
          <p style={{ fontWeight: 'bold' }}>
          Privacy policy
          </p>
          <p>
          7. BCA respects the privacy of every individual who visits BCA’s websites and is always careful to ensure that information disclosed to BCA in confidence is treated confidentially. Please see BCA’s full privacy policy.
          </p>
          
          <img src={abt_first} alt="About us image" className="city-image20" />

          <p style={{ fontWeight: 'bold' }}>
          Limitation of liability
          </p>
          <p>
          8. Nothing in these terms and conditions shall be taken to limit or exclude any liability that may not otherwise be limited or excluded under applicable law. Use of the BCA Websites and the Materials are at your sole risk. BCA will not be liable to any person for any direct, indirect, special or consequential, losses, damages or awards of any kind, howsoever caused, as a result of the use of or inability to use, or reliance on, the BCA Websites or any of the Materials. BCA excludes all warranties, conditions, terms, undertakings and representations (excepting fraudulent misrepresentation) of any kind, express or implied, statutory or otherwise in connection with the BCA Websites and the Materials to the fullest extent permitted by law.
          </p>
          <p style={{ fontWeight: 'bold' }}>
          Disclaimer
          </p>
          <p>
          9. The Materials and the BCA Websites are provided on an “as is” and “as available” basis. BCA gives no warranties (express, implied or statutory) as to satisfactory quality or fitness for purpose of the Materials or that any of the Materials or the BCA Websites will be provided uninterrupted or free from errors or that any identified defect will be corrected. BCA has the right to suspend or withdraw the provision of all or any of the BCA Websites or the Material without prior notice at any time. Further, no warranty of any kind is given that the BCA Websites and the Materials are free from any virus or other malicious, destructive or corrupting code, program or macro. BCA does not warrant that the BCA Websites or the server(s) that make(s) them available are free of any virus or other harmful elements.
          </p>
          <p>
          10. Reference in the BCA Websites and/or the Materials to any hypertext link, product, process or service does not imply BCA’s support for, nor endorsement or recommendation of, the provider thereof or the product, process or service to which reference is made. The BCA Websites may contain hypertext links to other websites, resources or other third parties. BCA is not responsible for the availability of, and accepts no liability in relation to, these external websites or their contents. BCA is not a sponsor, partner, promoter or publisher of any of such websites.
          </p>
          <p style={{ fontWeight: 'bold' }}>
          Copyright and trademarks
          </p>

          <p>
          11. The Materials are the copyright of BCA and its third-party licensors and may not be copied, distributed, uploaded, posted, republished, decompiled, disassembled, reverse-engineered or transmitted in any way without the prior, written consent of BCA. You may, however, download one copy for your personal non-commercial use or non-commercial use within the organisation in which you work on condition that you do not delete or change any copyright, trademark or other proprietary notice contained in the Materials nor alter the way in which they are presented. Modification or use other than as permitted above violates BCA’s intellectual property rights in the Materials.
          </p>
          <p>
          12. The trademarks, service marks and logo (the “Trade Marks”) used and displayed on the BCA Websites are registered and unregistered Trade Marks of BCA and others. Nothing in these terms and conditions or on the BCA Websites should be construed as granting any license or right to use any Trademark displayed on the BCA Websites. BCA enforces infringements of its intellectual property rights to the fullest extent permitted by the law.
          </p>
          <p style={{ fontWeight: 'bold' }}>
          Further information about BCA and the BCA Websites
          </p>
          <p>
          13. Bay Capital Advisors, Inc. is authorised and regulated to conduct appropriate business activities under United States law and the Uniform Commercial Code. BCA nor any of its affiliates is a registered broker/dealer in the United States or any other country. The United States or any of its regulatory agencies do not otherwise regulate the activities carried on by BCA outside the US.
          </p>
          <p>
          14. The information in the BCA Websites is only for the attention of the residents of jurisdictions where it can be lawfully disseminated.
          </p>
          <img src={abt_first1} alt="About us image" className="city-image21" />


          <p style={{ fontWeight: 'bold' }}>
          Governing law
          </p>
          <p>
          15. The agreement between BCA and you relating to your use and browsing of the BCA Websites is governed by and shall be construed in accordance with United States and International Law where applicable. These terms and conditions may not be modified unless BCA agrees in writing.
          </p>
          <p style={{ fontWeight: 'bold' }}>
          Resources Page terms and conditions
          </p>
          <p>
          16. Use of the Resources page of BCA’s websites is subject to the following terms and conditions, in addition to the general terms and conditions of use of the BCA Websites. By using the page and any associated links, documents, or any other information you acknowledge that you have read, understood and agreed to be bound by all of these terms and conditions.
          </p>
          <p style={{ fontWeight: 'bold' }}>
          No representations or warranties
          </p>
          <p>
          17. The Resources page is not a complete listing of all information on a company or topic. The articles, research, links, and other information is provided for general information purposes only and should not be used as a basis for making business or investment decisions. BCA makes no representation and gives no warranties (express, implied or statutory) as to the accuracy, completeness or currency, or as to the fitness for any purpose, of any information provided in the Materials and it should not be relied upon as such. The descriptions of the businesses of companies included in the articles or links have been provided by such companies. Although BCA has used reasonable efforts to check the content of the information, BCA cannot guarantee the accuracy or completeness of such content, which BCA has included in the website in good faith. BCA accepts no responsibility to update any information on the BCA Websites or in the articles or links provided.
          </p>

          <p style={{ fontWeight: 'bold' }}>
          No invitation or inducement to engage in investment activity and no financial advice
          </p>
          <p>
          18. In providing information about BCA’s business activities:
          </p>
         
          <ol>
                <li>
                1. BCA is not communicating and does not intend to communicate any invitation or inducement to any person to make any investment or divestment or to engage in investment activity and is not offering to acquire of dispose of securities;
                </li>
                <li>
                2. BCA is not issuing, promulgating or providing any financial or other advice to any person; and
                </li>
                <li>
                3. BCA does not intend to make and is not making an offer or solicitation in relation to the shares of any company included on the website.
                </li>
          </ol>
          <p style={{ fontWeight: 'bold' }}>
          Intellectual property and copyright in the Database
          </p>

          <p>
          19. The information provided is the intellectual property of BCA, Inc. and/or BCA’s third-party service providers. None of the content or data may be reproduced, transferred, or modified without BCA’s written consent or the consent of the copyright and trademark holder of the information provided on the BCA website. BCA may change the information on the website at any time without notice and may, in its sole discretion at any time, remove all or any part of the information from the BCA website.
          </p>
          <p>
          20. Information contained in website is the copyright of BCA or a third-party copyright holder and may not be copied, distributed, uploaded, posted, republished, decompiled, disassembled, reverse-engineered or transmitted in any way without the prior, written consent of BCA.
          </p>

          <p style={{ fontWeight: 'bold' }}>
          Hypertext links on the Websites
          </p>
          <p>
          21. The BCA Websites contain hypertext links to websites owned or operated by various companies and information sources. Such links are provided for information only. BCA is not responsible for the availability or security of these external websites or their contents and accepts no liability for, and gives no endorsement of, material on or other services provided through such websites. Any use of such material or services is at your own risk.
          </p>

          <p style={{ fontWeight: 'bold', fontSize: '20px' }}>
          No broker-dealer registrations
          </p>
          <p>
          22. The information in the Database is provided free of charge and for information purposes only. BCA is not acting, nor is it seeking to act, as a broker or dealer in respect of the companies or securities of the companies listed in the Website or the information concerning such companies, nor will BCA receive any compensation for the provision of such information.
          </p>

      </div>
      <div className='separate-p1'>
      <p>
          Last updated on 26 June 2024
          </p>
      </div>
      {/* Footer Section */}
     <div className="footer-section">
        <nav>
          <a href="/CoreValues">Core Values</a>
          <a href="/Resources">Resources</a>
          <a href="/ContactUs">Contact Us</a>
        </nav>
        <div className="footer-logo">
                <Link to="/"> {/* Add this Link wrapper */}
                  <img src={logo1} alt="Bay Capital Advisors Logo" className="logo" />
                </Link>
                </div>
        <nav>
          <a href="/PrivacyPolicy">Privacy Policy</a>
          <a href="/TermsOfService">Terms of Service</a>
        </nav>
      </div>
    </div>
  );
};

export default TermsOfService;
